export const CAR_CONFIG_PRICE_TYPES: { [key: string]: string } = {
  BASE: 'Base',
  SECONDARY: 'MLP',
  PRIMARY: 'RDP',
  FITTED: 'Fitted',
  FULL: 'TotalBalance',
};
